<div class="bg-white rounded-lg shadow-sm p-6 w-full max-w-md">
  <h2 class="text-xl font-bold mb-4">Resumen del pedido</h2>

  <div class="space-y-4">
    <!-- Productos -->
    <div class="flex justify-between items-center">
      <span class="text-gray-700">Costo de productos</span>
      <span class="font-medium">${{total}}</span>
    </div>

    <!-- Costo de envío -->
    <div class="flex justify-between items-center">
      <span class="text-gray-700">Costo de envío</span>
      @if(isShippingFree){
        <span class="font-medium text-green-600"> Gratis</span>
        }@else {
        <span class="font-medium">${{shippingCost}}</span>
      }

    </div>
 <!-- Tarifa base -->
    <!-- <div class="flex justify-between items-center">
      <span class="text-gray-700">Tarifa base</span>
      @if(isShippingFree){
        <span class="font-medium text-green-600"> Gratis</span>
        }@else {
        <span class="font-medium">${{tarifaBase()}}</span>
      }

    </div> -->
    <!-- Tarifa de servicio -->
    <div class="flex justify-between items-center">
      <span class="text-gray-700">Tarifa de servicio</span>
      @if(isShippingFree){
        <span class="font-medium text-green-600"> Gratis</span>
        }@else {
        <span class="font-medium">${{tarifaServicio()}}</span>
      }

    </div>
    <!-- Distancia por servicio -->
    <!-- <div class="flex justify-between items-center">
      <span class="text-gray-700">Distancia</span>
      <span class="font-medium">{{distance}} km</span>
    </div> -->

    <div class="flex justify-between items-center">
      <span class="text-gray-700">Propina</span>
      <span class="font-medium">${{tip}}</span>
    </div>

    <!-- Línea divisoria -->
    <div class="border-t border-gray-200 my-2"></div>

    <!-- Subtotal antes de descuento -->
    <div class="flex justify-between items-center">
      <span class="text-gray-700">Subtotal</span>
      @if (isShippingFree) {
        <span class="font-medium">${{(total + tip +tarifaServicio()).toFixed(2)}}</span>|
      }
      @if (!isShippingFree) {
        <span class="font-medium">${{(total + tip + shippingCost + tarifaBase() + tarifaServicio()).toFixed(2)}}</span>
      }
    </div>

    <!-- Descuento por balance -->
    @if (balance() !== undefined && balance() !== null && balance() !== '0.00') {
      <div class="flex justify-between items-center">
        <span class="text-gray-700">Descuento aplicado</span>
        <span class="font-medium text-green-600">-${{descountBalanceC()}}</span>
      </div>
    }

    <!-- Línea divisoria -->
    <div class="border-t border-gray-200 my-2"></div>

    <!-- Total final -->
    <div class="flex justify-between items-center">
      <span class="text-lg font-bold">Total a pagar</span>
      <span class="text-lg font-bold">${{calculateTotal()}}</span>
    </div>
  </div>
</div>
